import {ArrowDownOutlined, ArrowUpOutlined} from "@ant-design/icons";
import React from "react";
import { blue, cyan, volcano} from "@ant-design/colors";
import {Col, Row, Tag} from "antd";
import Chip from '@mui/material/Chip';



const typeMap = {
    b: "Block",
    s: "Sleeve",
    m: "Model",
}
const typeColorMap = {
    b: volcano[9],
    s: blue[7],
    m: cyan[7],
}


const fieldColorMap = {
    dividend: 'linear-gradient(#1325AC, #211475)',
    equity: 'linear-gradient(#15B9B7, #66E1DF)',
    fixed: 'linear-gradient(#333333, #dd1818)',
    etf: 'linear-gradient(#1325AC, #211475)',
    growth: 'linear-gradient(#1325AC, #211475)',
    value: 'linear-gradient(#1325AC, #211475)',
    mixed: 'linear-gradient(#1D2671, #C33764)',
}


const fieldToIconMap = {
    global: {
        bg: 'linear-gradient(#1325AC, #211475)',
        label: "GL"
    },
    stock: {
        bg: 'linear-gradient(to bottom left, #1E9600, #FFF200, #FF0000)',
        label: "SS"
    },
}



// Custom renderer for the PnL column
const renderPnL = (text, record) => {
    try {
        const pnl = record.stats.summary.ytd * 100; // Assuming this is a percentage
        const isPositive = pnl >= 0;
        const arrow = isPositive ? <ArrowUpOutlined/> : <ArrowDownOutlined/>;
        const color = isPositive ? 'green' : 'red';
        return (
            <span style={{color}}>
          {arrow} {Math.abs(pnl).toFixed(2)}%
        </span>
        );
    }
    catch(e) {
        return <div>---</div>
    }
};

const colorByHoldingCount = (n)=>{
    if (n === 0){
        return 'red'
    }
    if (n < 10) {
        return '';
    } else if (n < 20) {
        return 'green';
    } else {
        return 'blue';
    }
}




// Assuming typeColorMap and fieldColorMap are defined somewhere in your project
const defaultAvatarStyle = { background: 'radial-gradient(#1A1E23, rgb(13, 42, 76))' };

export const PortfolioAvatars = ({ userTags, minAvatars = 0 }) => {
  let avatars = [];

  if (userTags) {
    Object.keys(userTags).forEach(key => {
      const type = userTags[key];
      const style = { background: fieldColorMap?.[type] ?? defaultAvatarStyle.background, border: 'none', color: '#fff' };
      avatars.push(
          <Tag style={style}>{type}</Tag>
      );
    });
  }

  return avatars.length === 0 ? <div>---</div> : (
    <Row wrap={true}>
      {avatars}
    </Row>
  );
};

export {renderPnL, colorByHoldingCount, typeMap}